import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(ToastrService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      let errorMessage = 'An unknown error occurred!';
      let errorType = 'error';
      let errorTitle = undefined;
      let html = false;

      (async () => {
        if (err.error instanceof Blob) {
          await new Promise((resolve, reject) => {
            const blobReader = new FileReader();
            blobReader.onload = () => {
              try {
                const jsonResponse = JSON.parse(blobReader.result as string);
                if (jsonResponse && jsonResponse.message) {
                  errorMessage = jsonResponse.message;
                  resolve(jsonResponse.message);
                }
              } catch (error) {
                console.error(error);
                reject(error);
              }
            };

            blobReader.readAsText(err.error);
          });
        } else {
          if (err.message || err.error?.message) {
            errorMessage = err.error?.message || err.message;
          }

          if (err.error?.type) {
            errorType = err.error.type;
          }

          if (err.error?.title) {
            errorTitle = err.error.title;
          }

          if (err?.error?.detail) {
            if (typeof err.error.detail === 'string') {
              errorTitle = err.error.detail;
            } else if (Array.isArray(err.error.detail)) {
              errorTitle = err.error.detail.map((err: any) => err?.msg).filter(Boolean).join(', ');
            }
          }

          const validationErrors = err.error?.validationErrors;
          if (validationErrors) {
            errorMessage += '<ul>';
            Object.keys(validationErrors).map(key => {
              errorMessage += `<li>${validationErrors[key]}</li>`;
            });
            errorMessage += '</ul>';
            html = true;
          }
        }

        try {
          if (req.headers.get('ignoreError') === 'true') {
            return;
          }

          if (err.status !== 404) {
            if (errorType === 'info') {
              toastr.info(errorMessage, errorTitle, {
                closeButton: true,
                enableHtml: html,
              });
            } else {
              toastr.error(errorMessage, errorTitle, {
                closeButton: true,
                enableHtml: html,
              });
            }
          }
        } catch (error) {
          console.error(error);
        }
      })();

      return throwError(() => err);
    })
  );
};
